import React from 'react'

import { Path } from '.'

export default function GraphQL() {
  return (
    <svg
      width={32}
      height={34}
      viewBox="0 0 32 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M2.47305 25.1944L3.72119 25.915L17.6259 1.83184L16.3778 1.1112L2.47305 25.1944Z"
        fill="gray3"
      />
      <Path d="M29.9972 23.2695H2.1875V24.7108H29.9972V23.2695Z" fill="gray3" />
      <Path
        d="M2.7379 24.0763L16.6479 32.1074L17.3686 30.8593L3.45854 22.8281L2.7379 24.0763Z"
        fill="gray3"
      />
      <Path
        d="M14.8214 3.14653L28.7314 11.1777L29.4521 9.92959L15.542 1.89839L14.8214 3.14653Z"
        fill="gray3"
      />
      <Path
        d="M2.74176 9.92373L3.4624 11.1719L17.3725 3.14069L16.6518 1.89255L2.74176 9.92373Z"
        fill="gray3"
      />
      <Path
        d="M14.5698 1.83186L28.4746 25.915L29.7228 25.1944L15.8179 1.11122L14.5698 1.83186Z"
        fill="gray3"
      />
      <Path
        d="M4.73082 8.96875H3.28955V25.0312H4.73082V8.96875Z"
        fill="gray3"
      />
      <Path
        d="M28.9022 8.96875H27.4609V25.0312H28.9022V8.96875Z"
        fill="gray3"
      />
      <Path
        d="M15.7724 30.4098L16.4019 31.5L28.4998 24.5151L27.8703 23.4248L15.7724 30.4098Z"
        fill="gray3"
      />
      <Path
        d="M30.8127 25.5002C29.9792 26.9501 28.1212 27.445 26.6712 26.6115C25.2213 25.778 24.7264 23.92 25.5599 22.47C26.3934 21.0201 28.2514 20.5252 29.7014 21.3587C31.16 22.2009 31.6549 24.0502 30.8127 25.5002Z"
        fill="gray3"
      />
      <Path
        d="M6.62375 11.5285C5.79025 12.9785 3.93222 13.4734 2.48226 12.6399C1.0323 11.8063 0.537405 9.94832 1.37091 8.49837C2.20442 7.04841 4.06245 6.55352 5.51241 7.38703C6.96237 8.22922 7.45726 10.0786 6.62375 11.5285Z"
        fill="gray3"
      />
      <Path
        d="M1.37921 25.5002C0.545706 24.0502 1.0406 22.2009 2.49056 21.3587C3.94052 20.5252 5.78986 21.0201 6.63205 22.47C7.46556 23.92 6.97067 25.7693 5.52071 26.6115C4.06207 27.445 2.21272 26.9501 1.37921 25.5002Z"
        fill="gray3"
      />
      <Path
        d="M25.5687 11.5285C24.7352 10.0786 25.2301 8.22922 26.68 7.38703C28.13 6.55352 29.9793 7.04841 30.8215 8.49837C31.655 9.94832 31.1601 11.7977 29.7102 12.6399C28.2602 13.4734 26.4022 12.9785 25.5687 11.5285Z"
        fill="gray3"
      />
      <Path
        d="M16.0966 33.9998C14.4209 33.9998 13.0664 32.6453 13.0664 30.9696C13.0664 29.2939 14.4209 27.9395 16.0966 27.9395C17.7723 27.9395 19.1267 29.2939 19.1267 30.9696C19.1267 32.6366 17.7723 33.9998 16.0966 33.9998Z"
        fill="gray3"
      />
      <Path
        d="M16.0966 6.0603C14.4209 6.0603 13.0664 4.70585 13.0664 3.03015C13.0664 1.35445 14.4209 0 16.0966 0C17.7723 0 19.1267 1.35445 19.1267 3.03015C19.1267 4.70585 17.7723 6.0603 16.0966 6.0603Z"
        fill="gray3"
      />
    </svg>
  )
}
